
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Import all Web Components
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = globalThis, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$o = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(o, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($3233927aa82734f9$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $3233927aa82734f9$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $27fcf98b67c2a783$var$i, defineProperty: $27fcf98b67c2a783$var$e, getOwnPropertyDescriptor: $27fcf98b67c2a783$var$h, getOwnPropertyNames: $27fcf98b67c2a783$var$r, getOwnPropertySymbols: $27fcf98b67c2a783$var$o, getPrototypeOf: $27fcf98b67c2a783$var$n } = Object, $27fcf98b67c2a783$var$a = globalThis, $27fcf98b67c2a783$var$c = $27fcf98b67c2a783$var$a.trustedTypes, $27fcf98b67c2a783$var$l = $27fcf98b67c2a783$var$c ? $27fcf98b67c2a783$var$c.emptyScript : "", $27fcf98b67c2a783$var$p = $27fcf98b67c2a783$var$a.reactiveElementPolyfillSupport, $27fcf98b67c2a783$var$d = (t, s)=>t, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, s)=>!$27fcf98b67c2a783$var$i(t, s), $27fcf98b67c2a783$var$b = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $27fcf98b67c2a783$var$a.litPropertyMetadata ??= new WeakMap;
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $27fcf98b67c2a783$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $27fcf98b67c2a783$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $27fcf98b67c2a783$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $27fcf98b67c2a783$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("elementProperties"))) return;
        const t = $27fcf98b67c2a783$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($27fcf98b67c2a783$var$d("properties"))) {
            const t = this.properties, s = [
                ...$27fcf98b67c2a783$var$r(t),
                ...$27fcf98b67c2a783$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3233927aa82734f9$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$Em = e, this[e] = h.fromAttribute(s, t.type) ?? this._$Ej?.get(e) ?? null, this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            const e = this.constructor, h = this[t];
            if (i ??= e.getPropertyOptions(t), !((i.hasChanged ?? $27fcf98b67c2a783$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(e._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("elementProperties")] = new Map, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("finalized")] = new Map, $27fcf98b67c2a783$var$p?.({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), ($27fcf98b67c2a783$var$a.reactiveElementVersions ??= []).push("2.1.0");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = "$lit$", $e5ed8027d647799b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$h, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$l = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$a = Array.isArray, $e5ed8027d647799b$var$u = (t)=>$e5ed8027d647799b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$d = "[ \t\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$_ = />/g, $e5ed8027d647799b$var$m = RegExp(`>|${$e5ed8027d647799b$var$d}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$d}*=${$e5ed8027d647799b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$p = /'/g, $e5ed8027d647799b$var$g = /"/g, $e5ed8027d647799b$var$$ = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$y(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$y(2), $e5ed8027d647799b$export$47d5b44d225be5b4 = $e5ed8027d647799b$var$y(3), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$A = new WeakMap, $e5ed8027d647799b$var$C = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129);
function $e5ed8027d647799b$var$P(t, i) {
    if (!$e5ed8027d647799b$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(i) : i;
}
const $e5ed8027d647799b$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e5ed8027d647799b$var$f ? "!--" === u[1] ? c = $e5ed8027d647799b$var$v : void 0 !== u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[2] ? ($e5ed8027d647799b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$m) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$m) : c === $e5ed8027d647799b$var$m ? ">" === u[0] ? (c = r ?? $e5ed8027d647799b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$m : '"' === u[3] ? $e5ed8027d647799b$var$g : $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$g || c === $e5ed8027d647799b$var$p ? c = $e5ed8027d647799b$var$m : c === $e5ed8027d647799b$var$v || c === $e5ed8027d647799b$var$_ ? c = $e5ed8027d647799b$var$f : (c = $e5ed8027d647799b$var$m, r = void 0);
        const x = c === $e5ed8027d647799b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e5ed8027d647799b$var$e + s.slice(d) + $e5ed8027d647799b$var$h + x) : s + $e5ed8027d647799b$var$h + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $e5ed8027d647799b$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$V(t, s);
        if (this.el = $e5ed8027d647799b$var$N.createElement(f, n), $e5ed8027d647799b$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$H : "?" === e[1] ? $e5ed8027d647799b$var$I : "@" === e[1] ? $e5ed8027d647799b$var$L : $e5ed8027d647799b$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e5ed8027d647799b$var$l()), $e5ed8027d647799b$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e5ed8027d647799b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e5ed8027d647799b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$S(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$r).importNode(i, !0);
        $e5ed8027d647799b$var$C.currentNode = e;
        let h = $e5ed8027d647799b$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e5ed8027d647799b$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e5ed8027d647799b$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e5ed8027d647799b$var$C.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$C.currentNode = $e5ed8027d647799b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$S(this, t, i), $e5ed8027d647799b$var$c(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$N.createElement($e5ed8027d647799b$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$A.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$A.set(t.strings, i = new $e5ed8027d647799b$var$N(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$R(this.O($e5ed8027d647799b$var$l()), this.O($e5ed8027d647799b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$S(this, t, i, 0), o = !$e5ed8027d647799b$var$c(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$S(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$c(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$L extends $e5ed8027d647799b$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$S(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$S(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    M: $e5ed8027d647799b$var$e,
    P: $e5ed8027d647799b$var$h,
    A: $e5ed8027d647799b$var$o,
    C: 1,
    L: $e5ed8027d647799b$var$V,
    R: $e5ed8027d647799b$var$M,
    D: $e5ed8027d647799b$var$u,
    V: $e5ed8027d647799b$var$S,
    I: $e5ed8027d647799b$var$R,
    H: $e5ed8027d647799b$var$k,
    N: $e5ed8027d647799b$var$I,
    U: $e5ed8027d647799b$var$L,
    B: $e5ed8027d647799b$var$H,
    F: $e5ed8027d647799b$var$z
}, $e5ed8027d647799b$var$j = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$j?.($e5ed8027d647799b$var$N, $e5ed8027d647799b$var$R), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.3.0");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$R(i.insertBefore($e5ed8027d647799b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fe586ba0757c37f7$var$s = globalThis;
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $27fcf98b67c2a783$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, $fe586ba0757c37f7$export$3f2f9f5909897157["finalized"] = !0, $fe586ba0757c37f7$var$s.litElementHydrateSupport?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$o = $fe586ba0757c37f7$var$s.litElementPolyfillSupport;
$fe586ba0757c37f7$var$o?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($fe586ba0757c37f7$var$s.litElementVersions ??= []).push("4.2.0");




var $e895b252dfe71b5d$exports = {};
$e895b252dfe71b5d$exports = import.meta.resolve("dgeE9");



class $0cf0050c5378a035$var$BottomTray extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static get properties() {
        return {
            isOpen: {
                type: Boolean
            },
            content: {
                type: Array
            },
            activePage: {
                type: String
            }
        };
    }
    constructor(){
        super();
        this.isOpen = false;
        this.content = [];
        this.activePage = '';
        this._onDocumentClick = this._onDocumentClick.bind(this);
        this._onWindowResize = this._onWindowResize.bind(this);
        this.lastWidth = window.innerWidth;
    }
    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('click', this._onDocumentClick);
        window.addEventListener('resize', this._onWindowResize);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('click', this._onDocumentClick);
        window.removeEventListener('resize', this._onWindowResize);
    }
    _onDocumentClick(event) {
        if (this.isOpen && !this.contains(event.target) && !event.target.closest('.hamburger-menu')) this.close();
    }
    _onWindowResize() {
        // Close the tray when window width changes
        const currentWidth = window.innerWidth;
        if (this.isOpen && currentWidth !== this.lastWidth) {
            this.close();
            // Also hide the overlay
            const overlay = document.querySelector('.tray-overlay');
            if (overlay) overlay.classList.remove('open');
        }
        // Hide the tray completely if width is >= 1300px
        if (currentWidth >= 1300 && this.isOpen) this.close();
        this.lastWidth = currentWidth;
    }
    open() {
        this.isOpen = true;
        this.classList.add('open');
        document.body.style.overflow = 'hidden';
        // Make sure the tray is above the overlay in the DOM structure
        const overlay = document.querySelector('.tray-overlay');
        if (overlay && overlay.parentNode) overlay.parentNode.insertBefore(this, overlay.nextSibling);
        // Center the active item after the tray is visible
        setTimeout(()=>{
            const activeElement = this.querySelector('.nav-link.active');
            if (activeElement) activeElement.scrollIntoView({
                behavior: 'instant',
                block: 'center'
            });
        }, 300);
    }
    close() {
        this.isOpen = false;
        this.classList.remove('open');
        document.body.style.overflow = '';
    }
    toggle() {
        if (this.isOpen) this.close();
        else this.open();
    }
    generateFilename = (categoryName, pageName, pageNumber)=>{
        const categorySlug = categoryName.toLowerCase().replace(/^\d+\.\s+/, '') // Remove leading numbers
        .replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
        const pageSlug = pageName.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
        const filename = `${pageNumber}-${categorySlug}-${pageSlug}.html`;
        pageNumber++;
        return filename;
    };
    getPageNumber = (categoryName, pageName)=>{
        let pageNumber = 1;
        let wasFound = false;
        return this.content.reduce((acc, category)=>{
            if (!wasFound) category.pages.forEach((page)=>{
                if (page.page_name === pageName) wasFound = true;
                if (!wasFound) pageNumber++;
            });
            return pageNumber;
        }, pageNumber);
    };
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <div class="bottom-tray ${this.isOpen ? 'open' : ''}">
                <div class="tray-header">
                    <div class="tray-handle"></div>
                    <button class="close-button" aria-label="Close menu" @click=${this.close} tabindex="0">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18" stroke="#54c4b3" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M6 6L18 18" stroke="#54c4b3" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <div class="tray-content">
                    <nav>
                        ${this.content ? this.content.map((category)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                                      <div class="section">
                                          <h3 class="section-title">${category.category_name}</h3>
                                          <ul class="nav-list">
                                              ${category.pages.map((page)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                                                      <li class="nav-item">
                                                          <a
                                                              href="${this.generateFilename(category.category_name, page.page_name, this.getPageNumber(category.category_name, page.page_name))}"
                                                              class="nav-link ${this.activePage === page.page_name ? 'active' : ''}"
                                                              tabindex="${this.isOpen ? '0' : '-1'}"
                                                              aria-label="${page.page_name}"
                                                          >
                                                              ${page.page_name}
                                                          </a>
                                                      </li>
                                                  `)}
                                          </ul>
                                      </div>
                                  `) : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div>No content available</div>`}
                    </nav>
                </div>
            </div>
        `;
    }
}
customElements.define('bottom-tray', $0cf0050c5378a035$var$BottomTray);


class $7443cb943b2d33bd$var$AppHeader extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static get properties() {
        return {
            activePage: {
                type: String
            },
            content: {
                type: Array
            }
        };
    }
    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }
    toggleMenu() {
        const bottomTray = document.querySelector('bottom-tray');
        if (bottomTray) {
            bottomTray.toggle();
            // Create or toggle overlay
            let overlay = document.querySelector('.tray-overlay');
            if (!overlay) {
                overlay = document.createElement('div');
                overlay.className = 'tray-overlay';
                // Insert overlay before the bottom tray to ensure proper stacking
                document.body.insertBefore(overlay, bottomTray);
                // Add click handler to close tray when overlay is clicked
                overlay.addEventListener('click', ()=>{
                    bottomTray.close();
                    overlay.classList.remove('open');
                });
            }
            if (bottomTray.isOpen) overlay.classList.add('open');
            else overlay.classList.remove('open');
        }
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <div class="header-container">
                <div class="logo" tabindex="0" aria-label="Academy Logo">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($e895b252dfe71b5d$exports))}" alt="UI UX Guide Logo" />
                </div>
                <div class="right-side">
                    <a
                        href="https://akritisingh.com"
                        class="external-link"
                        tabindex="0"
                        aria-label="External Link"
                        target="_blank"
                        rel="noopener"
                        >My Portfolio</a
                    >

                    <!-- Add hamburger menu here -->
                    <button
                        class="hamburger-menu"
                        aria-label="Hamburger Menu"
                        aria-expanded="false"
                        @click=${this.toggleMenu}
                    >
                        <span class="hamburger-icon">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M20 7L4 7" stroke="#54c4b3" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M20 12L4 12" stroke="#54c4b3" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M20 17L4 17" stroke="#54c4b3" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                        </span>
                    </button>
                </div>
            </div>

            <bottom-tray .content=${this.content} .activePage=${this.activePage}></bottom-tray>
        `;
    }
}
customElements.define('app-header', $7443cb943b2d33bd$var$AppHeader);



class $21acf69ad2107d5c$var$AppFooter extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static get properties() {
        return {};
    }
    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }
    render() {
        const currentYear = new Date().getFullYear();
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <div class="footer-container">
                <div class="copyright">© ${currentYear} <span>UI UX Guide</span>. All rights reserved.</div>

                <div class="message">
                    <span>
                        Created with
                        <svg
                            class="w-6 h-6 text-gray-800 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="#e37a70"
                            viewBox="0 0 24 24"
                        >
                            <path
                                d="m12.75 20.66 6.184-7.098c2.677-2.884 2.559-6.506.754-8.705-.898-1.095-2.206-1.816-3.72-1.855-1.293-.034-2.652.43-3.963 1.442-1.315-1.012-2.678-1.476-3.973-1.442-1.515.04-2.825.76-3.724 1.855-1.806 2.201-1.915 5.823.772 8.706l6.183 7.097c.19.216.46.34.743.34a.985.985 0 0 0 .743-.34Z"
                            />
                        </svg>
                        by Akriti Singh.
                    </span>
                </div>

                <div class="links">
                    <a href="https://akritisingh.com/projects" class="footer-link" tabindex="0" aria-label="My Projects"
                        >My Projects</a
                    >
                    <a href="https://akritisingh.com/about-me" class="footer-link" tabindex="0" aria-label="About Me"
                        >About Me</a
                    >
                    <a
                        href="https://akritisingh.com/contact-me"
                        class="footer-link"
                        tabindex="0"
                        aria-label="Contact Me"
                        >Contact Me</a
                    >
                </div>
            </div>
        `;
    }
}
customElements.define('app-footer', $21acf69ad2107d5c$var$AppFooter);



class $62d55174885e0e2e$var$AppSideNav extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static get properties() {
        return {
            content: {
                type: Array
            },
            activePage: {
                type: String
            }
        };
    }
    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }
    generateFilename = (categoryName, pageName, pageNumber)=>{
        const categorySlug = categoryName.toLowerCase().replace(/^\d+\.\s+/, '') // Remove leading numbers
        .replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
        const pageSlug = pageName.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
        const filename = `${pageNumber}-${categorySlug}-${pageSlug}.html`;
        pageNumber++;
        return filename;
    };
    getPageNumber = (categoryName, pageName)=>{
        // Count the pages until the current page
        let pageNumber = 1;
        let wasFound = false;
        return this.content.reduce((acc, category)=>{
            if (!wasFound) category.pages.forEach((page)=>{
                if (page.page_name === pageName) wasFound = true;
                if (!wasFound) pageNumber++;
            });
            return pageNumber;
        }, pageNumber);
    };
    updated(changedProperties) {
        if (changedProperties.has('content')) {
            // The active element may be out of view, so we need to scroll to it
            const activeElement = document.querySelector('#main-nav .nav-list .nav-item a.active');
            if (activeElement) // activeElement.scrollIntoView({ behavior: 'instant', block: 'center' });
            // the layout might not be updated yet, so we need to wait for the next tick
            setTimeout(()=>{
                activeElement.scrollIntoView({
                    behavior: 'instant',
                    block: 'center'
                });
            }, 50);
        }
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <nav>
                ${this.content ? this.content.map((category)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                              <div class="section">
                                  <h3 class="section-title">${category.category_name}</h3>
                                  <ul class="nav-list">
                                      ${category.pages.map((page)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                                              <li class="nav-item">
                                                  <a
                                                      href="${this.generateFilename(category.category_name, page.page_name, this.getPageNumber(category.category_name, page.page_name))}"
                                                      class="nav-link ${this.activePage === page.page_name ? 'active' : ''}"
                                                      tabindex="0"
                                                      aria-label="${page.page_name}"
                                                  >
                                                      ${page.page_name}
                                                  </a>
                                              </li>
                                          `)}
                                  </ul>
                              </div>
                          `) : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div>No content available</div>`}
            </nav>
        `;
    }
}
customElements.define('app-sidenav', $62d55174885e0e2e$var$AppSideNav);



class $cd413de924a97183$var$AppPageNav extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static get properties() {
        return {
            headings: {
                type: Array
            }
        };
    }
    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <nav>
                <h3 class="title">On This Page</h3>
                <ul class="nav-list">
                    ${this.headings ? this.headings.map((heading)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
                                  <li class="nav-item">
                                      <a
                                          href="#${this._generateId(heading)}"
                                          class="nav-link"
                                          tabindex="0"
                                          aria-label="${heading}"
                                          >${heading}</a
                                      >
                                  </li>
                              `) : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<li class="nav-item">No headings available</li>`}
                </ul>
            </nav>
        `;
    }
    _generateId(text) {
        return text.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
    }
}
customElements.define('app-pagenav', $cd413de924a97183$var$AppPageNav);



class $f23b741adccd6f62$var$AppPagination extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static get properties() {
        return {
            prevPage: {
                type: Object
            },
            nextPage: {
                type: Object
            }
        };
    }
    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <div class="pagination">
                ${this.prevPage ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)` <a
                          href="${this.prevPage.url}"
                          class="pagination-btn prev"
                          tabindex="0"
                          aria-label="Previous: ${this.prevPage.title}"
                          @keydown=${(e)=>this._handleKeyDown(e, this.prevPage.url)}
                      >
                          <svg
                              class="arrow-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                          >
                              <line x1="19" y1="12" x2="5" y2="12"></line>
                              <polyline points="12 19 5 12 12 5"></polyline>
                          </svg>
                          <div class="page-text">
                              <span class="direction">Previous</span>
                              <span class="title">${this.prevPage.title}</span>
                          </div>
                      </a>` : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div></div>`}
                ${this.nextPage ? (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<a
                          href="${this.nextPage.url}"
                          class="pagination-btn next"
                          tabindex="0"
                          aria-label="Next: ${this.nextPage.title}"
                          @keydown=${(e)=>this._handleKeyDown(e, this.nextPage.url)}
                      >
                          <div class="page-text">
                              <span class="direction">Next</span>
                              <span class="title">${this.nextPage.title}</span>
                          </div>
                          <svg
                              class="arrow-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                          >
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                              <polyline points="12 5 19 12 12 19"></polyline>
                          </svg>
                      </a>` : (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div></div>`}
            </div>
        `;
    }
    _handleKeyDown(e, url) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.location.href = url;
        }
    }
}
customElements.define('app-pagination', $f23b741adccd6f62$var$AppPagination);


var $3a19fbaadf776224$exports = {};
$3a19fbaadf776224$exports = import.meta.resolve("jH1ni");


var $9382884b180f679d$exports = {};
$9382884b180f679d$exports = import.meta.resolve("77kw2");


var $98e758e7c2153758$exports = {};
$98e758e7c2153758$exports = import.meta.resolve("eSpEd");


var $e62b5062cb78a6bc$exports = {};
$e62b5062cb78a6bc$exports = import.meta.resolve("dEslr");


var $7f7b5d6a025cc26f$exports = {};
$7f7b5d6a025cc26f$exports = import.meta.resolve("7KiV0");


var $cf212a723b6efd46$exports = {};
$cf212a723b6efd46$exports = import.meta.resolve("gw4K0");


var $562718926cae3ff3$exports = {};
$562718926cae3ff3$exports = import.meta.resolve("8Y4Xv");


var $489f0fb3731f52da$exports = {};
$489f0fb3731f52da$exports = import.meta.resolve("axjWj");


var $2875198a2e145d84$exports = {};
$2875198a2e145d84$exports = import.meta.resolve("e8v8H");


var $810e3de0c2c95b87$exports = {};
$810e3de0c2c95b87$exports = import.meta.resolve("fblhM");


var $4b84c0045ea5bd0b$exports = {};
$4b84c0045ea5bd0b$exports = import.meta.resolve("cJU4n");


var $c117280855d8a85c$exports = {};
$c117280855d8a85c$exports = import.meta.resolve("4Ec8i");


var $94f09e5e64fbf375$exports = {};
$94f09e5e64fbf375$exports = import.meta.resolve("ffSeX");


var $855fa9f62ed16125$exports = {};
$855fa9f62ed16125$exports = import.meta.resolve("2dCVX");


var $a0787641561d654b$exports = {};
$a0787641561d654b$exports = import.meta.resolve("ggn6b");


var $95f1694f6079d020$exports = {};
$95f1694f6079d020$exports = import.meta.resolve("cZrFs");


var $4cad6123bf38f4fc$exports = {};
$4cad6123bf38f4fc$exports = import.meta.resolve("eXVdv");


var $e3ed757f22adcca1$exports = {};
$e3ed757f22adcca1$exports = import.meta.resolve("kNnud");


var $3ef1bdfb785fb1db$exports = {};
$3ef1bdfb785fb1db$exports = import.meta.resolve("7V4Nt");


var $2948faa7a2781896$exports = {};
$2948faa7a2781896$exports = import.meta.resolve("9Yvtv");


var $f3262d91cf981ec1$exports = {};
$f3262d91cf981ec1$exports = import.meta.resolve("iE7nJ");


var $8d8061b9af138510$exports = {};
$8d8061b9af138510$exports = import.meta.resolve("0OxIG");


var $52d5da9657e227f4$exports = {};
$52d5da9657e227f4$exports = import.meta.resolve("fmoK9");


var $f74f751a7f2692e0$exports = {};
$f74f751a7f2692e0$exports = import.meta.resolve("dp1lT");


var $2f4c52243061c4c6$exports = {};
$2f4c52243061c4c6$exports = import.meta.resolve("eDxfe");


var $4f2c3e1463669bc6$exports = {};
$4f2c3e1463669bc6$exports = import.meta.resolve("73tgg");


var $beac583b1ca11074$exports = {};
$beac583b1ca11074$exports = import.meta.resolve("95na6");


var $ae86b3b39210d6ee$exports = {};
$ae86b3b39210d6ee$exports = import.meta.resolve("bYYrB");


var $9e99b8197e0a9fb1$exports = {};
$9e99b8197e0a9fb1$exports = import.meta.resolve("DA5wH");


var $b4108aff18b08acb$exports = {};
$b4108aff18b08acb$exports = import.meta.resolve("3RUvm");


var $42fcc859954115c0$exports = {};
$42fcc859954115c0$exports = import.meta.resolve("c7zPh");


var $5d7033cea17d9bcc$exports = {};
$5d7033cea17d9bcc$exports = import.meta.resolve("lObE4");


var $1829eac0688ea32d$exports = {};
$1829eac0688ea32d$exports = import.meta.resolve("2NBN7");


var $44cf33e17b2fb1b6$exports = {};
$44cf33e17b2fb1b6$exports = import.meta.resolve("gSJnD");


var $5a7fd2eeda268257$exports = {};
$5a7fd2eeda268257$exports = import.meta.resolve("iRJKG");


var $cc5c54291fd0651a$exports = {};
$cc5c54291fd0651a$exports = import.meta.resolve("imrUc");


var $7f69307d72025c50$exports = {};
$7f69307d72025c50$exports = import.meta.resolve("j5tVA");


var $32b1693bae53f51a$exports = {};
$32b1693bae53f51a$exports = import.meta.resolve("YBkko");


var $deeaf2b03c4d99dc$exports = {};
$deeaf2b03c4d99dc$exports = import.meta.resolve("8XG05");


var $3d0c0f5746d701eb$exports = {};
$3d0c0f5746d701eb$exports = import.meta.resolve("lVlf1");


var $02d29dc02eaae228$exports = {};
$02d29dc02eaae228$exports = import.meta.resolve("iSBbf");


var $fd996911c7231869$exports = {};
$fd996911c7231869$exports = import.meta.resolve("kgXdw");


var $afddac112a2aa974$exports = {};
$afddac112a2aa974$exports = import.meta.resolve("4jMhF");


var $12434eb2e07dd570$exports = {};
$12434eb2e07dd570$exports = import.meta.resolve("7qDep");


var $3591bbc7e3c9b780$exports = {};
$3591bbc7e3c9b780$exports = import.meta.resolve("555Bk");


var $b128e67824739618$exports = {};
$b128e67824739618$exports = import.meta.resolve("hfiWi");


var $81c7e8d123310afe$exports = {};
$81c7e8d123310afe$exports = import.meta.resolve("eGEaO");


var $675a53c01fab73e6$exports = {};
$675a53c01fab73e6$exports = import.meta.resolve("gDslk");


var $8c1eb635564979f8$exports = {};
$8c1eb635564979f8$exports = import.meta.resolve("4ZDck");


var $21932007968d63ad$exports = {};
$21932007968d63ad$exports = import.meta.resolve("fCwnM");


var $b7ddbad9a6dec85e$exports = {};
$b7ddbad9a6dec85e$exports = import.meta.resolve("gUhOP");


var $259ebe35a09cdee1$exports = {};
$259ebe35a09cdee1$exports = import.meta.resolve("aScfJ");


var $8b7bdb9ddeec4d6a$exports = {};
$8b7bdb9ddeec4d6a$exports = import.meta.resolve("habUU");


var $eba24cb33e9e482e$exports = {};
$eba24cb33e9e482e$exports = import.meta.resolve("58X8p");


var $7b2ff48699fd119e$exports = {};
$7b2ff48699fd119e$exports = import.meta.resolve("hnLpV");


var $c2c54fa5037b07a4$exports = {};
$c2c54fa5037b07a4$exports = import.meta.resolve("iNLHN");


var $9c3996c4401927a1$exports = {};
$9c3996c4401927a1$exports = import.meta.resolve("kqCa6");


var $c8744505824d8cbc$exports = {};
$c8744505824d8cbc$exports = import.meta.resolve("iEnsu");


var $057c84bba0b9c565$exports = {};
$057c84bba0b9c565$exports = import.meta.resolve("cu46O");


var $877c91cd181eed21$exports = {};
$877c91cd181eed21$exports = import.meta.resolve("kvtT4");


var $e59e7ff8c08c4b1a$exports = {};
$e59e7ff8c08c4b1a$exports = import.meta.resolve("iP8kX");


var $2aa87d3b75ca5a19$exports = {};
$2aa87d3b75ca5a19$exports = import.meta.resolve("cDcaE");


var $6381aba3f49352cb$exports = {};
$6381aba3f49352cb$exports = import.meta.resolve("dJxjD");


var $05ce70e46d67b9a4$exports = {};
$05ce70e46d67b9a4$exports = import.meta.resolve("inZeD");


var $de9ad2ef2a96da7b$exports = {};
$de9ad2ef2a96da7b$exports = import.meta.resolve("asbYO");


var $52d6e11c8fb943ff$exports = {};
$52d6e11c8fb943ff$exports = import.meta.resolve("lWGZ4");


var $3d5dc9500d41701e$exports = {};
$3d5dc9500d41701e$exports = import.meta.resolve("8DF3B");


var $3d8b947feba8e447$exports = {};
$3d8b947feba8e447$exports = import.meta.resolve("kwwBl");


var $a4974d144f024e4b$exports = {};
$a4974d144f024e4b$exports = import.meta.resolve("4eVoE");


var $2948118761a9e8b0$exports = {};
$2948118761a9e8b0$exports = import.meta.resolve("gnOqq");


var $93bae5621732cc3a$exports = {};
$93bae5621732cc3a$exports = import.meta.resolve("1g1yy");


var $2bfbba70a5da0d2c$exports = {};
$2bfbba70a5da0d2c$exports = import.meta.resolve("dFzcA");


var $0681e6cb8a91bd04$exports = {};
$0681e6cb8a91bd04$exports = import.meta.resolve("7lJvL");


var $292e0871e198c78b$exports = {};
$292e0871e198c78b$exports = import.meta.resolve("gjeZs");


var $ea97e3381c14fe3d$exports = {};
$ea97e3381c14fe3d$exports = import.meta.resolve("eNzho");


var $c5811e9c4e092e81$exports = {};
$c5811e9c4e092e81$exports = import.meta.resolve("RrwIX");


var $004abe944d4918f8$exports = {};
$004abe944d4918f8$exports = import.meta.resolve("6F3Vx");


var $e153e1fa3c3b4e45$exports = {};
$e153e1fa3c3b4e45$exports = import.meta.resolve("h5RNc");


var $43580ec0bef44884$exports = {};
$43580ec0bef44884$exports = import.meta.resolve("5LLM6");


var $04b03ac67b1d4067$exports = {};
$04b03ac67b1d4067$exports = import.meta.resolve("jaTvH");


var $2eb34c417bf98121$exports = {};
$2eb34c417bf98121$exports = import.meta.resolve("6vAtW");


var $83ed85c1b01c8cc5$exports = {};
$83ed85c1b01c8cc5$exports = import.meta.resolve("jQPjt");


var $e18c9cc392838ecf$exports = {};
$e18c9cc392838ecf$exports = import.meta.resolve("1sERg");


var $a992f0af474fb558$exports = {};
$a992f0af474fb558$exports = import.meta.resolve("kU0sV");


var $069636323fa952d6$exports = {};
$069636323fa952d6$exports = import.meta.resolve("ccELQ");


var $f0332605a8070c16$exports = {};
$f0332605a8070c16$exports = import.meta.resolve("KP0VT");


var $c598ee655d4689b3$exports = {};
$c598ee655d4689b3$exports = import.meta.resolve("nSe5u");


var $620dbd0ac7d63fac$exports = {};
$620dbd0ac7d63fac$exports = import.meta.resolve("6VWnb");


var $6ca22122d499ff6e$exports = {};
$6ca22122d499ff6e$exports = import.meta.resolve("2kN9W");


var $497b397973b7e1b8$exports = {};
$497b397973b7e1b8$exports = import.meta.resolve("1iAzO");


var $e868b1f508b2fbd1$exports = {};
$e868b1f508b2fbd1$exports = import.meta.resolve("id1Xh");


var $5842409c50d3502f$exports = {};
$5842409c50d3502f$exports = import.meta.resolve("41xJW");


var $ec83691213f7891e$exports = {};
$ec83691213f7891e$exports = import.meta.resolve("3TwW7");


var $6793a39ba2529207$exports = {};
$6793a39ba2529207$exports = import.meta.resolve("4pwMF");


var $56d0277dda4280df$exports = {};
$56d0277dda4280df$exports = import.meta.resolve("8nmJy");


var $1335f66a3eaa8778$exports = {};
$1335f66a3eaa8778$exports = import.meta.resolve("fVeUY");


var $5551d40a4a726f92$exports = {};
$5551d40a4a726f92$exports = import.meta.resolve("cZc1n");


var $bca00d87e9d38faf$exports = {};
$bca00d87e9d38faf$exports = import.meta.resolve("hyg4C");


var $58253c8d986ea3a5$exports = {};
$58253c8d986ea3a5$exports = import.meta.resolve("9Shvc");


var $44cc237f85461072$exports = {};
$44cc237f85461072$exports = import.meta.resolve("ccxOt");


var $411852d389570098$exports = {};
$411852d389570098$exports = import.meta.resolve("4AUo3");


var $e59f5b055a42e0ae$exports = {};
$e59f5b055a42e0ae$exports = import.meta.resolve("iywHN");


var $1c4266ced6f9a2d7$exports = {};
$1c4266ced6f9a2d7$exports = import.meta.resolve("aCcGp");


var $1a1880ce2d5a15f8$exports = {};
$1a1880ce2d5a15f8$exports = import.meta.resolve("4TO6O");


var $8cbd54f0be928561$exports = {};
$8cbd54f0be928561$exports = import.meta.resolve("kIdHe");


var $e9143f492f3ed902$exports = {};
$e9143f492f3ed902$exports = import.meta.resolve("65IPV");


var $bd1df1eeeb56c796$exports = {};
$bd1df1eeeb56c796$exports = import.meta.resolve("3rNtt");


var $f48a4f2787e8bee9$exports = {};
$f48a4f2787e8bee9$exports = import.meta.resolve("b7hCX");


var $05c3ad9c97fa85bf$exports = {};
$05c3ad9c97fa85bf$exports = import.meta.resolve("aR7zw");


var $703e48e599886c93$exports = {};
$703e48e599886c93$exports = import.meta.resolve("lMQA8");


var $f261da2a539846a2$exports = {};
$f261da2a539846a2$exports = import.meta.resolve("hWGCn");


var $0483d0a3232ced29$exports = {};
$0483d0a3232ced29$exports = import.meta.resolve("gmMJ2");


var $4d4b3b56b338cfba$exports = {};
$4d4b3b56b338cfba$exports = import.meta.resolve("5HJ7Y");


var $65cf605e0ab67339$exports = {};
$65cf605e0ab67339$exports = import.meta.resolve("aE6DT");


var $fd2b26da23143472$exports = {};
$fd2b26da23143472$exports = import.meta.resolve("j5nXC");


var $d745e916dd038a9a$exports = {};
$d745e916dd038a9a$exports = import.meta.resolve("8i2wA");


var $377bf56adfb21429$exports = {};
$377bf56adfb21429$exports = import.meta.resolve("dP3UY");


var $bb92c777e44cb2ca$exports = {};
$bb92c777e44cb2ca$exports = import.meta.resolve("isfpF");


var $c08511d2e825ac6a$exports = {};
$c08511d2e825ac6a$exports = import.meta.resolve("dyxFq");


var $332a26814c5fd946$exports = {};
$332a26814c5fd946$exports = import.meta.resolve("aZ4XO");


var $232a6279f1a3af76$exports = {};
$232a6279f1a3af76$exports = import.meta.resolve("bRrnj");


var $7547161ec6402a15$exports = {};
$7547161ec6402a15$exports = import.meta.resolve("3JwTH");


var $764c97724fa8c595$exports = {};
$764c97724fa8c595$exports = import.meta.resolve("fzFe2");


var $a1060a5438d198da$exports = {};
$a1060a5438d198da$exports = import.meta.resolve("jDLFl");


var $c4d1726040deb1af$exports = {};
$c4d1726040deb1af$exports = import.meta.resolve("8C4zf");


var $e4a435a7ceb83498$exports = {};
$e4a435a7ceb83498$exports = import.meta.resolve("jzqzD");


var $f3ce83f0999f5880$exports = {};
$f3ce83f0999f5880$exports = import.meta.resolve("eIY25");


var $09230d3b114c6059$exports = {};
$09230d3b114c6059$exports = import.meta.resolve("76g0E");


var $66705789026577d2$exports = {};
$66705789026577d2$exports = import.meta.resolve("5SQb8");


var $d91eacf5563010ef$exports = {};
$d91eacf5563010ef$exports = import.meta.resolve("7rt95");


var $0815bee29fe0290e$exports = {};
$0815bee29fe0290e$exports = import.meta.resolve("9VAz9");


var $7e313a63c254ae9c$exports = {};
$7e313a63c254ae9c$exports = import.meta.resolve("bqGzI");


var $953694515c608c2a$exports = {};
$953694515c608c2a$exports = import.meta.resolve("kgMIY");


var $aa075898090d9362$exports = {};
$aa075898090d9362$exports = import.meta.resolve("dNlSA");


var $5c846fc3598394c7$exports = {};
$5c846fc3598394c7$exports = import.meta.resolve("hf7aS");


var $1ab1d90c493addd1$exports = {};
$1ab1d90c493addd1$exports = import.meta.resolve("eyVLL");


var $ab020dabbd762216$exports = {};
$ab020dabbd762216$exports = import.meta.resolve("dFrKE");


var $8b2284f16d2f7b08$exports = {};
$8b2284f16d2f7b08$exports = import.meta.resolve("bw6GC");


var $f91322a9d1649c13$exports = {};
$f91322a9d1649c13$exports = import.meta.resolve("aErnK");


var $858ad20a5db70f6a$exports = {};
$858ad20a5db70f6a$exports = import.meta.resolve("5sN6z");


var $da47c31d88e13331$exports = {};
$da47c31d88e13331$exports = import.meta.resolve("dfehe");


var $f0e5ec20e6367af6$exports = {};
$f0e5ec20e6367af6$exports = import.meta.resolve("4G8tT");


var $a3193ccb61ae2428$exports = {};
$a3193ccb61ae2428$exports = import.meta.resolve("8kEJt");


var $9d7ffb4e21ffa442$exports = {};
$9d7ffb4e21ffa442$exports = import.meta.resolve("2YCNe");


var $e6126d8471b03dc6$exports = {};
$e6126d8471b03dc6$exports = import.meta.resolve("ckEhy");


var $d0fc24b33a8ba238$exports = {};
$d0fc24b33a8ba238$exports = import.meta.resolve("lm0xI");


var $906cd07a4ef7a5ba$exports = {};
$906cd07a4ef7a5ba$exports = import.meta.resolve("iDjYy");


var $b9d5e0ecd75c054e$exports = {};
$b9d5e0ecd75c054e$exports = import.meta.resolve("cUcVP");


var $21d9ecc4459b85c1$exports = {};
$21d9ecc4459b85c1$exports = import.meta.resolve("amW2p");


var $26e872a86e55a25c$exports = {};
$26e872a86e55a25c$exports = import.meta.resolve("4mwjg");


var $f6e6670801b6c3c3$exports = {};
$f6e6670801b6c3c3$exports = import.meta.resolve("iBYdg");


var $73bbeb0f0d3f0498$exports = {};
$73bbeb0f0d3f0498$exports = import.meta.resolve("lJlEp");


var $59514f897027dd92$exports = {};
$59514f897027dd92$exports = import.meta.resolve("9VlBZ");


var $33b131c548b1c964$exports = {};
$33b131c548b1c964$exports = import.meta.resolve("h0bwQ");


var $ca83f52e8500a3b6$exports = {};
$ca83f52e8500a3b6$exports = import.meta.resolve("5h2MI");


var $0e02e7c38d4e178e$exports = {};
$0e02e7c38d4e178e$exports = import.meta.resolve("8FNty");


var $a2706023e0473b14$exports = {};
$a2706023e0473b14$exports = import.meta.resolve("88tb7");


var $85eefe2bd162a48a$exports = {};
$85eefe2bd162a48a$exports = import.meta.resolve("2yIRB");


var $18b6c8714726d7ba$exports = {};
$18b6c8714726d7ba$exports = import.meta.resolve("7ULdX");


var $00f1a279ca38a736$exports = {};
$00f1a279ca38a736$exports = import.meta.resolve("iHuxK");


var $7ad920fe36c4b8cf$exports = {};
$7ad920fe36c4b8cf$exports = import.meta.resolve("1R53p");


var $8b9c41ae3fab1537$exports = {};
$8b9c41ae3fab1537$exports = import.meta.resolve("bfzCF");


var $1f1174256cbe0d31$exports = {};
$1f1174256cbe0d31$exports = import.meta.resolve("fKnJo");


var $eaeb12f1bbe07cc6$exports = {};
$eaeb12f1bbe07cc6$exports = import.meta.resolve("1VZrL");


var $657f3064d40cf03b$exports = {};
$657f3064d40cf03b$exports = import.meta.resolve("5V6E2");


var $704e5a1a2b9fc3fd$exports = {};
$704e5a1a2b9fc3fd$exports = import.meta.resolve("5xhJZ");


var $d482c334f4b8f21a$exports = {};
$d482c334f4b8f21a$exports = import.meta.resolve("5Je2v");


var $b9579a90c7c70466$exports = {};
$b9579a90c7c70466$exports = import.meta.resolve("48K0w");


var $bbe095ac4779873e$exports = {};
$bbe095ac4779873e$exports = import.meta.resolve("9eJiB");


const $129f7a6e6d480e4b$var$mediaMap = {
    hero: (/*@__PURE__*/$parcel$interopDefault($3a19fbaadf776224$exports)),
    one: (/*@__PURE__*/$parcel$interopDefault($9382884b180f679d$exports)),
    two: (/*@__PURE__*/$parcel$interopDefault($98e758e7c2153758$exports)),
    three: (/*@__PURE__*/$parcel$interopDefault($e62b5062cb78a6bc$exports)),
    four: (/*@__PURE__*/$parcel$interopDefault($7f7b5d6a025cc26f$exports)),
    five: (/*@__PURE__*/$parcel$interopDefault($cf212a723b6efd46$exports)),
    six: (/*@__PURE__*/$parcel$interopDefault($562718926cae3ff3$exports)),
    seven: (/*@__PURE__*/$parcel$interopDefault($489f0fb3731f52da$exports)),
    eight: (/*@__PURE__*/$parcel$interopDefault($2875198a2e145d84$exports)),
    nine: (/*@__PURE__*/$parcel$interopDefault($810e3de0c2c95b87$exports)),
    ten: (/*@__PURE__*/$parcel$interopDefault($4b84c0045ea5bd0b$exports)),
    eleven: (/*@__PURE__*/$parcel$interopDefault($c117280855d8a85c$exports)),
    twelve: (/*@__PURE__*/$parcel$interopDefault($94f09e5e64fbf375$exports)),
    thirteen: (/*@__PURE__*/$parcel$interopDefault($855fa9f62ed16125$exports)),
    fourteen: (/*@__PURE__*/$parcel$interopDefault($a0787641561d654b$exports)),
    fifteen: (/*@__PURE__*/$parcel$interopDefault($95f1694f6079d020$exports)),
    sixteen: (/*@__PURE__*/$parcel$interopDefault($4cad6123bf38f4fc$exports)),
    seventeen: (/*@__PURE__*/$parcel$interopDefault($e3ed757f22adcca1$exports)),
    eighteen: (/*@__PURE__*/$parcel$interopDefault($3ef1bdfb785fb1db$exports)),
    nineteen: (/*@__PURE__*/$parcel$interopDefault($2948faa7a2781896$exports)),
    twenty: (/*@__PURE__*/$parcel$interopDefault($f3262d91cf981ec1$exports)),
    twentyone: (/*@__PURE__*/$parcel$interopDefault($8d8061b9af138510$exports)),
    twentytwo: (/*@__PURE__*/$parcel$interopDefault($52d5da9657e227f4$exports)),
    twentythree: (/*@__PURE__*/$parcel$interopDefault($f74f751a7f2692e0$exports)),
    twentyfour: (/*@__PURE__*/$parcel$interopDefault($2f4c52243061c4c6$exports)),
    twentyfive: (/*@__PURE__*/$parcel$interopDefault($4f2c3e1463669bc6$exports)),
    twentysix: (/*@__PURE__*/$parcel$interopDefault($beac583b1ca11074$exports)),
    twentyseven: (/*@__PURE__*/$parcel$interopDefault($ae86b3b39210d6ee$exports)),
    twentyeight: (/*@__PURE__*/$parcel$interopDefault($9e99b8197e0a9fb1$exports)),
    twentynine: (/*@__PURE__*/$parcel$interopDefault($b4108aff18b08acb$exports)),
    thirty: (/*@__PURE__*/$parcel$interopDefault($42fcc859954115c0$exports)),
    thirtyone: (/*@__PURE__*/$parcel$interopDefault($5d7033cea17d9bcc$exports)),
    thirtytwo: (/*@__PURE__*/$parcel$interopDefault($1829eac0688ea32d$exports)),
    thirtythree: (/*@__PURE__*/$parcel$interopDefault($44cf33e17b2fb1b6$exports)),
    thirtyfour: (/*@__PURE__*/$parcel$interopDefault($5a7fd2eeda268257$exports)),
    thirtyfive: (/*@__PURE__*/$parcel$interopDefault($cc5c54291fd0651a$exports)),
    thirtysix: (/*@__PURE__*/$parcel$interopDefault($7f69307d72025c50$exports)),
    thirtyseven: (/*@__PURE__*/$parcel$interopDefault($32b1693bae53f51a$exports)),
    thirtyeight: (/*@__PURE__*/$parcel$interopDefault($deeaf2b03c4d99dc$exports)),
    thirtynine: (/*@__PURE__*/$parcel$interopDefault($3d0c0f5746d701eb$exports)),
    forty: (/*@__PURE__*/$parcel$interopDefault($02d29dc02eaae228$exports)),
    fortyone: (/*@__PURE__*/$parcel$interopDefault($fd996911c7231869$exports)),
    fortytwo: (/*@__PURE__*/$parcel$interopDefault($afddac112a2aa974$exports)),
    fortythree: (/*@__PURE__*/$parcel$interopDefault($12434eb2e07dd570$exports)),
    fortyfour: (/*@__PURE__*/$parcel$interopDefault($3591bbc7e3c9b780$exports)),
    fortyfive: (/*@__PURE__*/$parcel$interopDefault($b128e67824739618$exports)),
    fortysix: (/*@__PURE__*/$parcel$interopDefault($81c7e8d123310afe$exports)),
    fortyseven: (/*@__PURE__*/$parcel$interopDefault($675a53c01fab73e6$exports)),
    fortyeight: (/*@__PURE__*/$parcel$interopDefault($8c1eb635564979f8$exports)),
    fortynine: (/*@__PURE__*/$parcel$interopDefault($21932007968d63ad$exports)),
    fifty: (/*@__PURE__*/$parcel$interopDefault($b7ddbad9a6dec85e$exports)),
    fiftyone: (/*@__PURE__*/$parcel$interopDefault($259ebe35a09cdee1$exports)),
    fiftytwo: (/*@__PURE__*/$parcel$interopDefault($8b7bdb9ddeec4d6a$exports)),
    heuristics1: (/*@__PURE__*/$parcel$interopDefault($eba24cb33e9e482e$exports)),
    heuristics2: (/*@__PURE__*/$parcel$interopDefault($7b2ff48699fd119e$exports)),
    heuristics3: (/*@__PURE__*/$parcel$interopDefault($c2c54fa5037b07a4$exports)),
    heuristics4: (/*@__PURE__*/$parcel$interopDefault($9c3996c4401927a1$exports)),
    heuristics5: (/*@__PURE__*/$parcel$interopDefault($c8744505824d8cbc$exports)),
    heuristics6: (/*@__PURE__*/$parcel$interopDefault($057c84bba0b9c565$exports)),
    heuristics7: (/*@__PURE__*/$parcel$interopDefault($877c91cd181eed21$exports)),
    heuristics8: (/*@__PURE__*/$parcel$interopDefault($e59e7ff8c08c4b1a$exports)),
    heuristics9: (/*@__PURE__*/$parcel$interopDefault($2aa87d3b75ca5a19$exports)),
    heuristics10: (/*@__PURE__*/$parcel$interopDefault($6381aba3f49352cb$exports)),
    uxlaw1: (/*@__PURE__*/$parcel$interopDefault($05ce70e46d67b9a4$exports)),
    uxlaw2: (/*@__PURE__*/$parcel$interopDefault($de9ad2ef2a96da7b$exports)),
    uxlaw3: (/*@__PURE__*/$parcel$interopDefault($52d6e11c8fb943ff$exports)),
    uxlaw4: (/*@__PURE__*/$parcel$interopDefault($3d5dc9500d41701e$exports)),
    uxlaw5: (/*@__PURE__*/$parcel$interopDefault($3d8b947feba8e447$exports)),
    uxlaw6: (/*@__PURE__*/$parcel$interopDefault($a4974d144f024e4b$exports)),
    uxlaw7: (/*@__PURE__*/$parcel$interopDefault($2948118761a9e8b0$exports)),
    uxlaw8: (/*@__PURE__*/$parcel$interopDefault($93bae5621732cc3a$exports)),
    uxResearch1: (/*@__PURE__*/$parcel$interopDefault($2bfbba70a5da0d2c$exports)),
    uxResearch2: (/*@__PURE__*/$parcel$interopDefault($0681e6cb8a91bd04$exports)),
    biases1: (/*@__PURE__*/$parcel$interopDefault($292e0871e198c78b$exports)),
    secondSet1: (/*@__PURE__*/$parcel$interopDefault($ea97e3381c14fe3d$exports)),
    secondSet2: (/*@__PURE__*/$parcel$interopDefault($c5811e9c4e092e81$exports)),
    secondSet2_1: (/*@__PURE__*/$parcel$interopDefault($004abe944d4918f8$exports)),
    secondSet3: (/*@__PURE__*/$parcel$interopDefault($e153e1fa3c3b4e45$exports)),
    secondSet4: (/*@__PURE__*/$parcel$interopDefault($43580ec0bef44884$exports)),
    secondSet5: (/*@__PURE__*/$parcel$interopDefault($04b03ac67b1d4067$exports)),
    secondSet6: (/*@__PURE__*/$parcel$interopDefault($2eb34c417bf98121$exports)),
    secondSet7: (/*@__PURE__*/$parcel$interopDefault($83ed85c1b01c8cc5$exports)),
    secondSet7_1: (/*@__PURE__*/$parcel$interopDefault($e18c9cc392838ecf$exports)),
    secondSet8: (/*@__PURE__*/$parcel$interopDefault($a992f0af474fb558$exports)),
    secondSet9: (/*@__PURE__*/$parcel$interopDefault($069636323fa952d6$exports)),
    secondSet10: (/*@__PURE__*/$parcel$interopDefault($f0332605a8070c16$exports)),
    secondSet10_1: (/*@__PURE__*/$parcel$interopDefault($c598ee655d4689b3$exports)),
    secondSet11: (/*@__PURE__*/$parcel$interopDefault($620dbd0ac7d63fac$exports)),
    secondSet12: (/*@__PURE__*/$parcel$interopDefault($6ca22122d499ff6e$exports)),
    secondSet13: (/*@__PURE__*/$parcel$interopDefault($497b397973b7e1b8$exports)),
    secondSet13_1: (/*@__PURE__*/$parcel$interopDefault($e868b1f508b2fbd1$exports)),
    secondSet14: (/*@__PURE__*/$parcel$interopDefault($5842409c50d3502f$exports)),
    secondSet15: (/*@__PURE__*/$parcel$interopDefault($ec83691213f7891e$exports)),
    secondSet16: (/*@__PURE__*/$parcel$interopDefault($6793a39ba2529207$exports)),
    secondSet17: (/*@__PURE__*/$parcel$interopDefault($56d0277dda4280df$exports)),
    secondSet18: (/*@__PURE__*/$parcel$interopDefault($1335f66a3eaa8778$exports)),
    secondSet19: (/*@__PURE__*/$parcel$interopDefault($5551d40a4a726f92$exports)),
    secondSet20: (/*@__PURE__*/$parcel$interopDefault($bca00d87e9d38faf$exports)),
    secondSet21: (/*@__PURE__*/$parcel$interopDefault($58253c8d986ea3a5$exports)),
    secondSet22: (/*@__PURE__*/$parcel$interopDefault($44cc237f85461072$exports)),
    secondSet23: (/*@__PURE__*/$parcel$interopDefault($411852d389570098$exports)),
    secondSet24: (/*@__PURE__*/$parcel$interopDefault($e59f5b055a42e0ae$exports)),
    secondSet25: (/*@__PURE__*/$parcel$interopDefault($1c4266ced6f9a2d7$exports)),
    secondSet26: (/*@__PURE__*/$parcel$interopDefault($1a1880ce2d5a15f8$exports)),
    secondSet27: (/*@__PURE__*/$parcel$interopDefault($8cbd54f0be928561$exports)),
    secondSet28: (/*@__PURE__*/$parcel$interopDefault($e9143f492f3ed902$exports)),
    secondSet29: (/*@__PURE__*/$parcel$interopDefault($bd1df1eeeb56c796$exports)),
    secondSet30: (/*@__PURE__*/$parcel$interopDefault($f48a4f2787e8bee9$exports)),
    secondSet31: (/*@__PURE__*/$parcel$interopDefault($05c3ad9c97fa85bf$exports)),
    secondSet32: (/*@__PURE__*/$parcel$interopDefault($703e48e599886c93$exports)),
    secondSet33: (/*@__PURE__*/$parcel$interopDefault($f261da2a539846a2$exports)),
    secondSet34: (/*@__PURE__*/$parcel$interopDefault($0483d0a3232ced29$exports)),
    thirdSet1: (/*@__PURE__*/$parcel$interopDefault($4d4b3b56b338cfba$exports)),
    thirdSet2: (/*@__PURE__*/$parcel$interopDefault($65cf605e0ab67339$exports)),
    thirdSet3: (/*@__PURE__*/$parcel$interopDefault($fd2b26da23143472$exports)),
    thirdSet4: (/*@__PURE__*/$parcel$interopDefault($d745e916dd038a9a$exports)),
    thirdSet5: (/*@__PURE__*/$parcel$interopDefault($377bf56adfb21429$exports)),
    thirdSet6: (/*@__PURE__*/$parcel$interopDefault($bb92c777e44cb2ca$exports)),
    thirdSet7: (/*@__PURE__*/$parcel$interopDefault($c08511d2e825ac6a$exports)),
    thirdSet8: (/*@__PURE__*/$parcel$interopDefault($332a26814c5fd946$exports)),
    thirdSet9: (/*@__PURE__*/$parcel$interopDefault($232a6279f1a3af76$exports)),
    thirdSet10: (/*@__PURE__*/$parcel$interopDefault($7547161ec6402a15$exports)),
    thirdSet11: (/*@__PURE__*/$parcel$interopDefault($764c97724fa8c595$exports)),
    thirdSet12: (/*@__PURE__*/$parcel$interopDefault($a1060a5438d198da$exports)),
    thirdSet13: (/*@__PURE__*/$parcel$interopDefault($c4d1726040deb1af$exports)),
    thirdSet14: (/*@__PURE__*/$parcel$interopDefault($e4a435a7ceb83498$exports)),
    thirdSet15: (/*@__PURE__*/$parcel$interopDefault($f3ce83f0999f5880$exports)),
    thirdSet16: (/*@__PURE__*/$parcel$interopDefault($09230d3b114c6059$exports)),
    thirdSet17: (/*@__PURE__*/$parcel$interopDefault($66705789026577d2$exports)),
    thirdSet18: (/*@__PURE__*/$parcel$interopDefault($d91eacf5563010ef$exports)),
    thirdSet19: (/*@__PURE__*/$parcel$interopDefault($0815bee29fe0290e$exports)),
    thirdSet20: (/*@__PURE__*/$parcel$interopDefault($7e313a63c254ae9c$exports)),
    thirdSet21: (/*@__PURE__*/$parcel$interopDefault($953694515c608c2a$exports)),
    thirdSet22: (/*@__PURE__*/$parcel$interopDefault($aa075898090d9362$exports)),
    thirdSet23: (/*@__PURE__*/$parcel$interopDefault($5c846fc3598394c7$exports)),
    thirdSet24: (/*@__PURE__*/$parcel$interopDefault($1ab1d90c493addd1$exports)),
    thirdSet25: (/*@__PURE__*/$parcel$interopDefault($ab020dabbd762216$exports)),
    thirdSet26: (/*@__PURE__*/$parcel$interopDefault($8b2284f16d2f7b08$exports)),
    thirdSet27: (/*@__PURE__*/$parcel$interopDefault($f91322a9d1649c13$exports)),
    thirdSet28: (/*@__PURE__*/$parcel$interopDefault($858ad20a5db70f6a$exports)),
    thirdSet29: (/*@__PURE__*/$parcel$interopDefault($da47c31d88e13331$exports)),
    thirdSet30: (/*@__PURE__*/$parcel$interopDefault($f0e5ec20e6367af6$exports)),
    thirdSet31: (/*@__PURE__*/$parcel$interopDefault($a3193ccb61ae2428$exports)),
    thirdSet32: (/*@__PURE__*/$parcel$interopDefault($9d7ffb4e21ffa442$exports)),
    thirdSet33: (/*@__PURE__*/$parcel$interopDefault($e6126d8471b03dc6$exports)),
    thirdSet34: (/*@__PURE__*/$parcel$interopDefault($d0fc24b33a8ba238$exports)),
    thirdSet35: (/*@__PURE__*/$parcel$interopDefault($906cd07a4ef7a5ba$exports)),
    thirdSet36: (/*@__PURE__*/$parcel$interopDefault($b9d5e0ecd75c054e$exports)),
    thirdSet37: (/*@__PURE__*/$parcel$interopDefault($21d9ecc4459b85c1$exports)),
    thirdSet38: (/*@__PURE__*/$parcel$interopDefault($26e872a86e55a25c$exports)),
    thirdSet39: (/*@__PURE__*/$parcel$interopDefault($f6e6670801b6c3c3$exports)),
    thirdSet40: (/*@__PURE__*/$parcel$interopDefault($73bbeb0f0d3f0498$exports)),
    thirdSet41: (/*@__PURE__*/$parcel$interopDefault($59514f897027dd92$exports)),
    thirdSet42: (/*@__PURE__*/$parcel$interopDefault($33b131c548b1c964$exports)),
    thirdSet43: (/*@__PURE__*/$parcel$interopDefault($ca83f52e8500a3b6$exports)),
    thirdSet44: (/*@__PURE__*/$parcel$interopDefault($0e02e7c38d4e178e$exports)),
    thirdSet45: (/*@__PURE__*/$parcel$interopDefault($a2706023e0473b14$exports)),
    thirdSet46: (/*@__PURE__*/$parcel$interopDefault($85eefe2bd162a48a$exports)),
    thirdSet47: (/*@__PURE__*/$parcel$interopDefault($18b6c8714726d7ba$exports)),
    thirdSet48: (/*@__PURE__*/$parcel$interopDefault($00f1a279ca38a736$exports)),
    thirdSet49: (/*@__PURE__*/$parcel$interopDefault($7ad920fe36c4b8cf$exports)),
    thirdSet50: (/*@__PURE__*/$parcel$interopDefault($8b9c41ae3fab1537$exports)),
    thirdSet51: (/*@__PURE__*/$parcel$interopDefault($1f1174256cbe0d31$exports)),
    thirdSet52: (/*@__PURE__*/$parcel$interopDefault($eaeb12f1bbe07cc6$exports)),
    thirdSet53: (/*@__PURE__*/$parcel$interopDefault($657f3064d40cf03b$exports)),
    thirdSet54: (/*@__PURE__*/$parcel$interopDefault($704e5a1a2b9fc3fd$exports)),
    thirdSet55: (/*@__PURE__*/$parcel$interopDefault($d482c334f4b8f21a$exports)),
    thirdSet56: (/*@__PURE__*/$parcel$interopDefault($b9579a90c7c70466$exports)),
    thirdSet57: (/*@__PURE__*/$parcel$interopDefault($bbe095ac4779873e$exports))
};
class $129f7a6e6d480e4b$var$MediaContainer extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: 'open'
        });
    }
    static get observedAttributes() {
        return [
            'src',
            'type',
            'options',
            'description'
        ];
    }
    connectedCallback() {
        this.render();
        this.addEventListeners();
    }
    attributeChangedCallback() {
        if (this.shadowRoot.innerHTML !== '') this.render();
    }
    render() {
        const src = this.getAttribute('src') || '';
        const type = this.getAttribute('type') || 'image';
        const options = this.getAttribute('options') || '';
        const description = this.getAttribute('description') || '';
        // Parse options into attributes
        const optionsObj = options ? this.parseOptions(options) : {};
        const optionsString = Object.entries(optionsObj).map(([key, value])=>`${key}="${value}"`).join(' ');
        let mediaElement = '';
        if (type === 'image') mediaElement = `<img src="${$129f7a6e6d480e4b$var$mediaMap[src]}" alt="${description}" ${optionsString} />`;
        else if (type === 'video') mediaElement = `
        <video controls ${optionsString}>
          <source src="${src}" type="video/${src.split('.').pop()}">
          Your browser does not support the video tag.
        </video>
      `;
        this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          margin-bottom: var(--space-8, 2rem);
        }
        
        .media-container {
          width: 100%;
          cursor: pointer;
          border-radius: var(--border-radius-md, 0.5rem);
          overflow: hidden;
          transition: transform 0.2s ease;
          box-shadow: var(--shadow-md, 0 4px 6px rgba(0, 0, 0, 0.05));
        }
        
        .media-container:hover {
          transform: translateY(-2px);
        }
        
        img, video {
          display: block;
          width: 100%;
          height: auto;
          object-fit: contain;
        }
        
        .description {
          margin-top: var(--space-4, 1rem);
          text-align: center;
          color: var(--light-text-color, #6b7280);
          font-size: 0.925rem;
        }
        
        /* Modal styles */
        .modal {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.9);
          z-index: 1000;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        
        .modal.open {
          display: flex;
        }
        
        .modal-content {
          max-width: 90%;
          max-height: 80%;
        }
        
        .modal img, .modal video {
          max-width: 100%;
          max-height: 80vh;
          object-fit: contain;
        }
        
        .modal-description {
          color: white;
          margin-top: var(--space-4, 1rem);
          text-align: center;
          max-width: 80%;
          font-size: 1rem;
        }
        
        .close-btn {
          position: absolute;
          top: var(--space-4, 1rem);
          right: var(--space-4, 1rem);
          color: white;
          font-size: 2rem;
          cursor: pointer;
          background: none;
          border: none;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.5);
          transition: background-color 0.2s;
        }
        
        .close-btn:hover {
          background-color: rgba(0, 0, 0, 0.8);
        }
        
        @media (max-width: 768px) {
          .modal-content {
            max-width: 95%;
          }
        }
      </style>
      
      <div class="media-container" tabindex="0" aria-label="Click to view in fullscreen">
        ${mediaElement}
      </div>
      
      ${description ? `<div class="description">${description}</div>` : ''}
      
      <div class="modal" role="dialog" aria-label="Fullscreen media">
        <button class="close-btn" aria-label="Close fullscreen view">&times;</button>
        <div class="modal-content">
          ${mediaElement}
        </div>
        ${description ? `<div class="modal-description">${description}</div>` : ''}
      </div>
    `;
    }
    parseOptions(optionsStr) {
        const result = {};
        try {
            // Convert string like 'autoplay loop' to {autoplay: '', loop: ''}
            // Or 'width=500 height=300' to {width: '500', height: '300'}
            optionsStr.split(' ').forEach((opt)=>{
                if (opt.includes('=')) {
                    const [key, value] = opt.split('=');
                    result[key] = value;
                } else if (opt.trim()) result[opt.trim()] = '';
            });
        } catch (e) {
            console.error('Error parsing options', e);
        }
        return result;
    }
    addEventListeners() {
        const container = this.shadowRoot.querySelector('.media-container');
        const modal = this.shadowRoot.querySelector('.modal');
        const closeBtn = this.shadowRoot.querySelector('.close-btn');
        // Open modal on click
        container.addEventListener('click', ()=>this.openModal());
        // Keyboard accessibility for Enter key
        container.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.keyCode === 13) this.openModal();
        });
        // Close modal on close button click
        closeBtn.addEventListener('click', (e)=>{
            e.stopPropagation();
            this.closeModal();
        });
        // Close modal on Escape key
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' || e.keyCode === 27) this.closeModal();
        });
        // Close modal on click outside content
        modal.addEventListener('click', (e)=>{
            if (e.target === modal) this.closeModal();
        });
    }
    openModal() {
        const modal = this.shadowRoot.querySelector('.modal');
        modal.classList.add('open');
        document.body.style.overflow = 'hidden'; // Prevent scrolling while modal is open
    }
    closeModal() {
        const modal = this.shadowRoot.querySelector('.modal');
        modal.classList.remove('open');
        document.body.style.overflow = ''; // Restore scrolling
    }
}
customElements.define('media-container', $129f7a6e6d480e4b$var$MediaContainer);


// Set up page scrolling for PageNav
document.addEventListener('DOMContentLoaded', ()=>{
    // Handle smooth scrolling for in-page navigation
    document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) window.scrollTo({
                top: targetElement.offsetTop - 80,
                behavior: 'smooth'
            });
        });
    });
});


//# sourceMappingURL=1-introduction-to-uiux-defining-ui-ux-and-product-design.17861de9.js.map
